

export const fetchAssignmentFiltersSelectors = {
    languages: result => ({
        ...result,
        data: result?.data?.languages || [],
    }),
    courses: result => ({
        ...result,
        data: result?.data?.courses || [],
    }),
    organizations: result => ({
        ...result,
        data: result?.data?.organizations || [],
    }),
    types: result => ({
        ...result,
        data: result?.data?.types || [],
    }),
    owners: result => ({
        ...result,
        data: result?.data?.owners || [],
    }),
}

export const fetchAssignmentsSelectors = {
    byToken: (arg, result) => ({
        ...result,
        data: result?.data?.assignments?.find(assignment => assignment?.token === arg.token),
    }),
    selectPermissionLevelByToken: (arg, result) => {
        const assignment = result?.data?.assignments?.find(assignment => assignment?.token === arg.token);
        return {
            ...result,
            data: assignment?.permission_level,
        };
    },
    selectProcessingStatusByToken: (arg, result) => ({
        ...result,
        data: result?.data?.assignments?.find(assignment => assignment?.token === arg.token)?.current_version
            ?.processing_status,
    }),
    selectTypeByToken: (arg, result) => ({
        ...result,
        data: result?.data?.assignments?.find(assignment => assignment?.token === arg.token)?.assignment_type,
    }),
    selectDoesVersionHaveMbasByToken: (arg, result) => ({
        ...result,
        data: result?.data?.assignments?.find(assignment => assignment?.token === arg.token)?.current_version
            ?.is_editable,
    }),
    selectIsVersionPublishedByToken: (arg, result) => ({
        ...result,
        data: result?.data?.assignments?.find(assignment => assignment?.token === arg.token)?.current_version
            ?.is_published,
    }),
} 